import { GuestCovidVaccineRegisterPage } from './guest-covid-vaccine-register.page';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: GuestCovidVaccineRegisterPage,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GuestCovidVaccineRegisterPageRoutingModule {}
